import { render, staticRenderFns } from "./VkIconButton.vue?vue&type=template&id=1c13dad5&scoped=true&"
import script from "./VkIconButton.vue?vue&type=script&lang=js&"
export * from "./VkIconButton.vue?vue&type=script&lang=js&"
import style0 from "./VkIconButton.vue?vue&type=style&index=0&id=1c13dad5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c13dad5",
  null
  
)

export default component.exports